export type InsightCardWidth = 1 | 2 | 3 | 4;

const INSIGHT_CARD_WIDTH_CLASS: Record<InsightCardWidth, string> = {
    1: 'col-span-1 lg:col-span-1',
    2: 'col-span-1 lg:col-span-2',
    3: 'col-span-1 lg:col-span-3',
    4: 'col-span-1 lg:col-span-4'
};

export const getInsightCardWidthClass = (width: InsightCardWidth = 2): string => INSIGHT_CARD_WIDTH_CLASS[width];

/**
 * Shared 4-column insights layout; card widths are 1–4 via `InsightCard` / `getInsightCardWidthClass`.
 * Use `overflow-x-clip` (not `hidden`) so vertical overflow stays on the Insights scroll body —
 * `overflow-x: hidden` would force `overflow-y: auto` and nest a second scrollbar.
 */
export const INSIGHTS_GRID_CLASS_NAME = 'grid w-full min-w-0 grid-cols-1 items-stretch gap-4 overflow-x-clip lg:grid-cols-4';
